import axios from 'axios';
import moment from 'moment';
import { closeLoader, openLoader } from './app.action';
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const GET_ORDER_VIEW = 'GET_ORDER_VIEW';
export const NEW_NOTIFY_ORDER = 'NEW_NOTIFY_ORDER';

export const resendOrder = (orderId) => {
    return async (dispatch) => {
        dispatch(openLoader());
        try {
            await axios.post(`/app/orders/resend/${orderId}`);
        } catch(err) {
            console.log(err);
        } finally {
            dispatch(closeLoader());
        }
    }
};

export const newOrderNotify = (order) => ({
    type: NEW_NOTIFY_ORDER,
    payload: { ...order, maxTime: moment().add(5, 'seconds') }
});

export const getOrderView = (orderId) => {
    return async (dispatch) => {
        try{
            const response = await axios.get(`/app/orders/${orderId}`);
            dispatch({
                type: GET_ORDER_VIEW,
                payload: {
                    orderId, 
                    orderData: response.data
                }
            });
        }catch(err){
            console.log(err);
        }finally{
            dispatch(closeLoader());
        }
    }
};

export const getAllOrders = ({
        page=1, rowsPage=30, restaurantId='', storeId=undefined,
        dateFrom=moment().format('YYYY-MM-DD'), dateTo=moment().format('YYYY-MM-DD'), state=undefined, name=undefined, aggregatorId=undefined
    }) => {
    return async ( dispatch ) => {
        try{
            let filters = `from=${dateFrom}&to=${dateTo}&page=${page}&row=${rowsPage}`;
            if ( storeId ){
                filters+=`&storeId=${storeId}`;
            }
            if ( state ){
                filters+=`&state=${state}`;
            }
            dispatch(openLoader());
            const response = await axios.get(`/app/orders?${filters}`);
            dispatch({
                type: GET_ALL_ORDERS,
                payload: {
                    page, 
                    rowsPage, 
                    restaurantId, 
                    storeId, 
                    dateFrom, 
                    dateTo, 
                    state, 
                    name, 
                    aggregatorId,
                    rows: response.data.data,
                    nRows: response.data.count    
                }
            });
        }catch(err){
            console.log(err);
        }finally{
            dispatch(closeLoader());
        }
    }
};